import type { IHeatmapSeriesTheme } from '../../../../series/heatmap/interface';

export const heatmap: IHeatmapSeriesTheme = {
  cell: {
    style: {
      shape: 'square',
      fillOpacity: 1
    }
  },
  cellBackground: {
    visible: false
  }
};
